import localizationData from "./en.json";
import localized from "model/events/util";

const events = (context, setEvent) =>
  [
    {
      title: "event.amateur.toPickpocket.title",
      description: "event.amateur.toPickpocket.description",
      effect: { resources: { coins: 5 }, traits: { stealth: 1 } },
      buttons: [
        {
          title: "event.amateur.toPickpocket.button.accept",
          message: "event.amateur.toPickpocket.button.message.accept",
          effect: { resources: { coins: 10 }, traits: { stealth: 2 } },
        },
      ],
    },
    {
      title: "event.pickpocket.toMugger.title",
      description: "event.pickpocket.toMugger.description",
      buttons: [
        {
          title: "event.pickpocket.toMugger.button.accept",
          message: "event.pickpocket.toMugger.button.message.accept",
          effect: { traits: { infamy: 2 } },
        },
      ],
    },
    {
      title: "event.mugger.toConfidenceTrickster.title",
      description: "event.mugger.toConfidenceTrickster.description",
      effect: { traits: { charisma: 1 } },
      buttons: [
        {
          title: "event.mugger.toConfidenceTrickster.button.accept",
          message: "event.mugger.toConfidenceTrickster.button.message.accept",
          effect: { traits: { charisma: 2 } },
        },
      ],
    },
    {
      title: "event.confidenceTrickster.toFence.title",
      description: "event.confidenceTrickster.toFence.description",
      effect: { traits: { haggling: 1 } },
      buttons: [
        {
          title: "event.confidenceTrickster.toFence.button.accept",
          message: "event.confidenceTrickster.toFence.button.message.accept",
          effect: { traits: { haggling: 2 } },
        },
      ],
    },
    {
      title: "event.fence.toRustler.title",
      description: "event.fence.toRustler.description",
      effect: { traits: { resilience: 1, stealth: 1 } },
      buttons: [
        {
          title: "event.fence.toRustler.button.accept",
          message: "event.fence.toRustler.button.message.accept",
          effect: { traits: { resilience: 2, stealth: 2 } },
        },
      ],
    },
    {
      title: "event.rustler.toMuscle.title",
      description: "event.rustler.toMuscle.description",
      effect: { traits: { resilience: 2 } },
      buttons: [
        {
          title: "event.rustler.toMuscle.button.accept",
          message: "event.rustler.toMuscle.button.message.accept",
          effect: { traits: { resilience: 3 } },
        },
      ],
    },
    {
      title: "event.muscle.toHighwayman.title",
      description: "event.muscle.toHighwayman.description",
      effect: { traits: { resilience: 2, infamy: 2, stealth: 1 } },
      buttons: [
        {
          title: "event.muscle.toHighwayman.button.accept",
          message: "event.muscle.toHighwayman.button.message.accept",
          effect: { traits: { resilience: 1, infamy: 2 } },
        },
      ],
    },
    {
      title: "event.highwayman.toStagecoachRobber.title",
      description: "event.highwayman.toStagecoachRobber.description",
      effect: { traits: { resilience: 2, infamy: 2, stealth: 2, luck: 2 } },
      buttons: [
        {
          title: "event.highwayman.toStagecoachRobber.button.accept",
          message: "event.highwayman.toStagecoachRobber.button.message.accept",
          effect: { traits: { resilience: 2, infamy: 2, stealth: 2 } },
        },
      ],
    },
    {
      title: "event.stagecoachRobber.toLieutenant.title",
      description: "event.stagecoachRobber.toLieutenant.description",
      effect: { traits: { charisma: 3, infamy: 3 } },
      buttons: [
        {
          title: "event.stagecoachRobber.toLieutenant.button.accept",
          message: "event.stagecoachRobber.toLieutenant.button.message.accept",
          effect: { traits: { charisma: 2, infamy: 2 } },
        },
      ],
    },
    {
      title: "event.lieutenant.toOutlawLegend.title",
      description: "event.lieutenant.toOutlawLegend.description",
      effect: { traits: { charisma: 5, infamy: 5, stealth: 5, resilience: 5 } },
      buttons: [
        {
          title: "event.lieutenant.toOutlawLegend.button.accept",
          message: "event.lieutenant.toOutlawLegend.button.message.accept",
          effect: {
            traits: {
              charisma: 1,
              infamy: 1,
              stealth: 1,
              resilience: 1,
              luck: 5,
            },
          },
        },
      ],
    },
  ].map((event) => localized(event, localizationData));

export default events;
